import { action } from "../common/Action"
import { InterventiClient, InterventoData, InterventoDto, TipoIntervento, CatastiClient } from "../generated";
import { sortBy } from "lodash";

const service = new InterventiClient();

class InterventiActions {
    @action
    async getByCustomer(idCliente: number) {
        return {
            idCliente,
            interventi: (await service.getInterventiByCliente(idCliente))!,
        }
    };
    @action
    async getByTechnician(idTechnician: number, dataIntervento: Date, dataFineIntervento: Date) {
        return (await service.getByTechnician(idTechnician, dataIntervento, dataFineIntervento))!;
    }

    @action
    async getReportInterventi(from: Date, to: Date) {
        return {
            from,
            to,
            interventi: sortBy(await service.getReportInterventi(from, to), x => x.idIntervento),
        };
    };
    @action
    async add(intervento: InterventoData) {
        if (intervento.tipoIntervento == null || intervento.tipoIntervento.idTipoIntervento == null) {
            let defaultTipoIntervento = new TipoIntervento();
            defaultTipoIntervento.idTipoIntervento = 3;
            defaultTipoIntervento.descTipoIntervento = "Manutenzione";
            intervento.tipoIntervento = defaultTipoIntervento;
        }
        const id = await service.addIntervento(intervento);
        const result = new InterventoDto;
        result.init({ ...intervento, idIntervento: id } as InterventoDto);
        return result;
    };

    @action
    async update(intervento: InterventoData, id: number) {
        await service.updateIntervento(intervento, id);
        const result = new InterventoDto;
        result.init({ ...intervento, idIntervento: id } as InterventoDto);
        return result;
    };

    @action
    async delete(idCliente: number | undefined, idIntervento: number) {
        let result = await service.deleteIntervento(idIntervento);
        return { idCliente, idIntervento, deleteOk: result };
    };

    async downloadCatastoEsa(idInterventi: number[]) {
        const fileResponse = await new CatastiClient().getEsaExport(idInterventi.join(","));
        if (fileResponse != null) {
            //@ts-ignore
            import("file-saver")
                .then(instance => {
                    instance.default.saveAs(fileResponse.data, fileResponse.fileName ?? "cm-download")
                });

        }
    };

    async downloadCatastoSiert(idInterventi: number[], idAziendaSiert: number) {
        const fileResponse = await new CatastiClient().getSiertExport(idInterventi.join(","), idAziendaSiert);
        if (fileResponse != null) {
            //@ts-ignore
            import("file-saver")
                .then(instance => {
                    instance.default.saveAs(fileResponse.data, fileResponse.fileName ?? "cm-download")
                });

        }
    };


}
export default new InterventiActions();